<!--
 * @Author: 请在根目录下.vscode改成你的名字
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-09-29 09:07:14
 * @LastEditTime: 2019-09-29 09:07:14
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 -->
<!--入驻企业-->
<template>
  <div class="enterprise">
    <div class="enterprise-con">
      <div id="map" ref="map" :style="{width: '1200px', height: '720px'}" />
      <div class="enterprise-con-txt">
        <p class="enterprise-name">已入驻企业</p>
        <ul class="enterprise-ul">
          <li v-for="(item,index) in enterpriseArr" :key="index" class="enterprise-li">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/home/home.js' // 请求接口
export default {
  data() {
    return {
      //  入驻企业
      enterpriseNum: 0,
      enterpriseArr: []
    }
  },
  created() {
    //  地图入驻总数
    get.mapTotal().then(res => {
      // console.log(res)
      // this.enterpriseNum = res.result.number
      // 不足4位数 前面补0
      this.enterpriseNum = this.PrefixInteger(res.result)
      // 入驻企业计算
      const arrData = []
      const enterpriseLen = String(this.enterpriseNum).length
      for (let i = 0; i < enterpriseLen; i++) {
        arrData[i] = String(this.enterpriseNum).substr(i, 1)
      }
      this.enterpriseArr = arrData
    }).catch(error => {
      console.log(error)
    })
    //   地图数据
    get.mapData2().then(res => {
      console.log(res)
      const odata = []
      for (const value in res.result) {
        const item = {
          name: value,
          value: 1,
          num: res.result[value]
        }
        odata.push(item)
      }
      this.mapPlaceData = odata
      this.MapFn()
    })
  },
  methods: {
    PrefixInteger(num) {
      return (Array(4).join('0') + num).slice(-4)
    },
    // 地图
    MapFn() {
      //  地图Echarts
      const map = this.$echarts.init(this.$refs.map)
      var chinaGeoCoordMap = {
        '黑龙江': [127.9688, 45.368],
        '内蒙古': [110.3467, 41.4899],
        '吉林': [125.8154, 44.2584],
        '北京': [116.4551, 40.2539],
        '辽宁': [123.1238, 42.1216],
        '河北': [114.4995, 38.1006],
        '天津': [117.4219, 39.4189],
        '山西': [112.3352, 37.9413],
        '陕西': [109.1162, 34.2004],
        '甘肃': [103.5901, 36.3043],
        '宁夏': [106.3586, 38.1775],
        '青海': [101.4038, 36.8207],
        '新疆': [87.9236, 43.5883],
        '西藏': [91.11, 29.97],
        '四川': [103.9526, 30.7617],
        '重庆': [108.384366, 30.439702],
        '山东': [117.1582, 36.8701],
        '河南': [113.4668, 34.6234],
        '江苏': [118.8062, 31.9208],
        '安徽': [117.29, 32.0581],
        '湖北': [114.3896, 30.6628],
        '浙江': [119.5313, 29.8773],
        '福建': [119.4543, 25.9222],
        '江西': [116.0046, 28.6633],
        '湖南': [113.0823, 28.2568],
        '贵州': [106.6992, 26.7682],
        '云南': [102.9199, 25.4663],
        '广东': [113.12244, 23.009505],
        '广西': [108.479, 23.1152],
        '海南': [110.3893, 19.8516],
        '上海': [121.4648, 31.2891],
        '台湾': [121.5201, 25.0307],
        '香港': [114.1654, 22.2753],
        '澳门': [113.5491, 22.1987]
      }
      // var chinaDatas = [
      //   [{
      //     name: '黑龙江',
      //     value: 2,
      //     num: 5
      //   }]
      // ]
      var chinaDatas = this.mapPlaceData

      var series = [];
      [
        ['北京市', chinaDatas]
      ].forEach(function(item, i) {
        series.push({
          type: 'effectScatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: { // 涟漪特效
            period: 4, // 动画时间，值越小速度越快
            brushType: 'stroke', // 波纹绘制方式 stroke, fill
            scale: 6 // 波纹圆环最大限制，值越大波纹越大
          },
          label: { // 地区文字展示
            normal: {
              show: true,
              position: 'right', // 显示位置
              offset: [5, 0], // 偏移设置
              formatter: function(params) { // 圆环显示文字
                return params.data.name
              },
              fontSize: 13
            },
            emphasis: {
              show: true
            }
          },
          symbol: 'circle',
          symbolSize: function(val) {
            console.log(val)
            return 5 + val[2] * 5 // 圆环大小
          },
          itemStyle: {
            normal: {
              show: false,
              color: '#f53121'
            }
          },
          data: item[1].map(function(dataItem) {
            return {
              name: dataItem.name,
              value: chinaGeoCoordMap[dataItem.name].concat([dataItem.value]),
              num: dataItem.num
            }
          })
          // data: item[1].map(function(dataItem) {
          //   return {
          //     name: dataItem[0].name,
          //     value: chinaGeoCoordMap[dataItem[0].name].concat([dataItem[0].value]),
          //     num: dataItem[0].num
          //   }
          // })
        },
        )
      })
      map.setOption(
        {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(211,97,87, 0.7)',
            borderColor: '#FFFFCC',
            showDelay: 0,
            hideDelay: 0,
            enterable: true,
            transitionDuration: 0,
            extraCssText: 'z-index:100',
            formatter: function(params, ticket, callback) {
              // 根据业务自己拓展要显示的内容
              var res = ''
              const name = params.name
              const num = params.data.num
              res = '' +
                '<p style="color:#fff;">' + name + '</p>' +
                '<p style="color:#fff;">货源企业：' + num.goods + ' 家</p>' +
                '<p style="color:#fff;">运力企业：' + num.trsport + ' 家</p>' +
                '<p style="color:#fff;">仓需企业：' + num.demand + ' 家</p>' +
                '<p style="color:#fff;">供给企业：' + num.supply + ' 家</p>'
              return res
            }
          },
          backgroundColor: 'rgba(255,255,255,0)', // 背景底图
          // visualMap: { // 图例值控制
          //   min: 0,
          //   max: 1,
          //   calculable: true,
          //   show: true,
          //   color: ['#D1655B', '#fc9700', '#ffde00', '#ffde00', '#00eaff'],
          //   textStyle: {
          //     color: '#fff'
          //   }
          // },
          geo: {
            map: 'china',
            zoom: 1.2,
            label: {
              emphasis: {
                show: false
              }
            },
            roam: false, // 是否允许缩放
            itemStyle: {
              normal: {
                color: 'rgba(249,251,255, .8)', // 地图背景色
                borderColor: 'rgba(170,175,170, .5)', // 省市边界线00fcff 516a89
                borderWidth: 1
              },
              emphasis: {
                color: 'rgba(37, 43, 61, .5)' // 悬浮背景
              }
            }
          },
          series: series
        }
      )
    }
  }
}
</script>

<style scoped lang='scss'>
  .enterprise-con{
    position: relative;
    width: 1200px;
    height: 720px;
    .enterprise-con-txt{
      position: absolute;
      width: 400px;
      height: auto;
      top: 50px;
      left: 50%;
      margin-left: -200px;
      .enterprise-name{
        text-align: center;
        font-size:36px;
        color: #fff;
        /*亮瞎眼的文字特效*/
        /*text-shadow:0 0 5px #e0ea33,0 0 15px #e0ea33,0 0 25px #e0ea33;*/
      }
      .enterprise-ul{
        width: 400px;
        height: auto;
        text-align: center;
        padding-top: 20px;
        .enterprise-li{
          display: inline-block;
          width: 30px;
          height: 48px;
          line-height: 48px;
          border-radius:3px;
          color: #AC3223;
          background: #BDCAD2;
          font-size: 32px;
          margin: 0 5px;
        }
      }
    }
  }
</style>
